var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.4C3 12.3595 3 9.83929 3.98094 7.91409C4.8438 6.22063 6.22063 4.8438 7.91409 3.98094C9.83929 3 12.3595 3 17.4 3H30.6C35.6405 3 38.1607 3 40.0859 3.98094C41.7794 4.8438 43.1562 6.22063 44.0191 7.91409C45 9.83929 45 12.3595 45 17.4V30.6C45 35.6405 45 38.1607 44.0191 40.0859C43.1562 41.7794 41.7794 43.1562 40.0859 44.0191C38.1607 45 35.6405 45 30.6 45H17.4C12.3595 45 9.83929 45 7.91409 44.0191C6.22063 43.1562 4.8438 41.7794 3.98094 40.0859C3 38.1607 3 35.6405 3 30.6V17.4Z",
    fill: "url(#paint0_linear_126_46280)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4128 15.04C34.1422 13.12 31.4174 12.16 28.5413 12L28.0872 12.48C30.6606 13.12 32.9312 14.4 35.0505 16.16C32.4771 14.72 29.6009 13.76 26.5734 13.44C25.6651 13.28 24.9083 13.28 24 13.28C23.0917 13.28 22.3349 13.28 21.4266 13.44C18.3991 13.76 15.5229 14.72 12.9495 16.16C15.0688 14.4 17.3394 13.12 19.9128 12.48L19.4587 12C16.5826 12.16 13.8578 13.12 11.5872 15.04C9.01376 20.16 7.65138 25.92 7.5 31.84C9.77064 34.4 12.9495 36 16.2798 36C16.2798 36 17.3394 34.72 18.0963 33.6C16.1284 33.12 14.3119 32 13.1009 30.24C14.1606 30.88 15.2202 31.52 16.2798 32C17.6422 32.64 19.0046 32.96 20.367 33.28C21.578 33.44 22.789 33.6 24 33.6C25.211 33.6 26.422 33.44 27.633 33.28C28.9954 32.96 30.3578 32.64 31.7202 32C32.7798 31.52 33.8395 30.88 34.8991 30.24C33.6881 32 31.8716 33.12 29.9037 33.6C30.6606 34.72 31.7202 36 31.7202 36C35.0505 36 38.2294 34.4 40.5 31.84C40.3486 25.92 38.9862 20.16 36.4128 15.04ZM19.0046 28.96C17.4908 28.96 16.1284 27.52 16.1284 25.76C16.1284 24 17.4908 22.56 19.0046 22.56C20.5183 22.56 21.8807 24 21.8807 25.76C21.8807 27.52 20.5183 28.96 19.0046 28.96ZM28.9954 28.96C27.4817 28.96 26.1193 27.52 26.1193 25.76C26.1193 24 27.4817 22.56 28.9954 22.56C30.5092 22.56 31.8716 24 31.8716 25.76C31.8716 27.52 30.5092 28.96 28.9954 28.96Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_46280",
    x1: 24,
    y1: 3,
    x2: 24,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#687EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5971C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.c01fcb4050bcb624c69dc3accd20aef4.svg";
export { ForwardRef as ReactComponent };